(function () {
  var MOBILE_BREAKPOINT = 767;

  function isMobileView() {
    return window.innerWidth <= MOBILE_BREAKPOINT;
  }

  function readBool(value) {
    return value === 'true' || value === true;
  }

  function readSpeed(root, fallback) {
    var speed = parseInt(root.getAttribute('data-slider-autoplay-speed'), 10);
    return Number.isFinite(speed) ? speed : fallback;
  }

  function saveOriginalHtml(root) {
    if (!root.dataset.originalHtml) {
      root.dataset.originalHtml = root.innerHTML;
    }
  }

  function restoreOriginalHtml(root) {
    if (root.dataset.originalHtml) {
      root.innerHTML = root.dataset.originalHtml;
    }
  }

  function flattenForMobile(root) {
    var fragment = document.createDocumentFragment();

    root.querySelectorAll('.custom-review-item').forEach(function (item) {
      var wrap = item.querySelector('.custom-review-item-wrap');
      if (!wrap) return;

      var parts = [
        wrap.querySelector('.custom-review-item-img-left'),
        wrap.querySelector('.custom-review-item-data'),
        wrap.querySelector('.custom-review-item-img-right'),
      ];

      parts.forEach(function (part) {
        if (!part) return;

        var slide = document.createElement('div');
        slide.className = 'custom-review-item custom-review-item--single';

        var newWrap = document.createElement('div');
        newWrap.className = 'custom-review-item-wrap';
        newWrap.appendChild(part.cloneNode(true));

        slide.appendChild(newWrap);
        fragment.appendChild(slide);
      });
    });

    root.innerHTML = '';
    root.appendChild(fragment);
  }

  function prepareSliderDom(root) {
    saveOriginalHtml(root);
    restoreOriginalHtml(root);

    if (isMobileView()) {
      flattenForMobile(root);
    }
  }

  function getSlickSettings($, root, section) {
    var mobile = isMobileView();

    if (mobile) {
      return {
        autoplay: readBool(root.getAttribute('data-slider-autoplay')),
        autoplaySpeed: readSpeed(root, 5000),
        speed: 800,
        infinite: true,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: false,
        centerMode: true,
        centerPadding: '0',
        variableWidth: true,
        adaptiveHeight: false,
        appendDots: $(section.querySelector('.slick-slider-pagination')),
        prevArrow: $(section.querySelector('.prevArrow')),
        nextArrow: $(section.querySelector('.nextArrow')),
      };
    }

    return {
      autoplay: readBool(root.getAttribute('data-slider-autoplay')),
      autoplaySpeed: readSpeed(root, 5000),
      speed: 800,
      infinite: true,
      dots: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      swipeToSlide: true,
      centerMode: true,
      centerPadding: '40px',
      variableWidth: true,
      adaptiveHeight: false,
      appendDots: $(section.querySelector('.slick-slider-pagination')),
      prevArrow: $(section.querySelector('.prevArrow')),
      nextArrow: $(section.querySelector('.nextArrow')),
      responsive: [
        {
          breakpoint: 1023,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '0',
            variableWidth: true,
          },
        },
      ],
    };
  }

  function initSlider($, root) {
    var section = root.closest('[data-section]');
    if (!section) return;

    var $slider = $(root);

    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }

    prepareSliderDom(root);
    $slider.slick(getSlickSettings($, root, section));
    root.classList.add('mila-index-slider-ready');
    root.dataset.reviewSliderMode = isMobileView() ? 'mobile' : 'desktop';
  }

  function initAll($) {
    document.querySelectorAll('[data-section] .custom-review-slider').forEach(function (root) {
      initSlider($, root);
    });
  }

  function bindResize($) {
    if (window.MilaCustomReviewSliderResizeBound) return;
    window.MilaCustomReviewSliderResizeBound = true;

    var resizeTimer;

    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        document.querySelectorAll('[data-section] .custom-review-slider').forEach(function (root) {
          var currentMode = root.dataset.reviewSliderMode;
          var nextMode = isMobileView() ? 'mobile' : 'desktop';

          if (currentMode !== nextMode) {
            initSlider($, root);
          }
        });
      }, 200);
    });
  }

  window.MilaCustomReviewSlider = {
    init: function ($) {
      initAll($);
      bindResize($);
    },
  };
})();
